import type { FC } from 'react';
import { Link } from 'react-router-dom';

import {
    Container,
    LogoContainer,
    Header,
    NavContainer,
    Content,
} from './styled';

import { UIRoutes } from '../../../constants/UIRoutes';
import { Icon, IconName } from '../../Icon';

interface IPublicLayoutProps {
    navigation?: React.ReactNode;
}

export const PublicLayout: FC<IPublicLayoutProps> = ({
    navigation,
    children,
}) => {
    return (
        <Container>
            <Header>
                <LogoContainer>
                    <Link to={UIRoutes.OVERVIEW}>
                        <Icon iconName={IconName.LOGO_DARK} />
                    </Link>
                </LogoContainer>
                <NavContainer>{navigation}</NavContainer>
            </Header>
            <Content>{children}</Content>
        </Container>
    );
};

PublicLayout.defaultProps = {
    navigation: null,
};
